<div class="meta">
    <app-textarea [formGroup]="$any(formGroup())" [model]="model()" [meta]="dataMeta"></app-textarea>
</div>
